import { type FC, type ReactNode } from "react";

import { Group, Paper, Text } from "@mantine/core";

import styles from "./EnrolledProgram.module.css";
import { EmptyValue } from "./messages.generated";

interface StatTileProps {
    label: ReactNode;
    value: ReactNode;
    caption?: ReactNode;
}

export const StatTile: FC<StatTileProps> = ({ label, value, caption }) => (
    <Paper className={styles.tile}>
        <Group className={styles.labelGroup}>
            <Text className={styles.tileLabel}>{label}</Text>
        </Group>
        <div className="heading-h300">
            {value ?? (
                <Text span inherit className={styles.muted}>
                    <EmptyValue />
                </Text>
            )}
        </div>
        {caption && <Text className={styles.caption}>{caption}</Text>}
    </Paper>
);
